import { render } from "./FeaturingPage.vue?vue&type=template&id=62fcf71d"
import script from "./FeaturingPage.vue?vue&type=script&lang=js"
export * from "./FeaturingPage.vue?vue&type=script&lang=js"

import "./FeaturingPage.vue?vue&type=style&index=0&id=62fcf71d&lang=css"

import exportComponent from "C:\\Users\\Urakehn\\Documents\\Developpement\\R42\\EasyProf_landing\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__